export const DialogSizePreset = ['small', 'medium', 'large', 'full'] as const;
export type DialogSizePreset = (typeof DialogSizePreset)[number];
